module.exports = __webpack_public_path__ + "static/Footer banner short -  Green Copy-1-a34745075dd455ae39d320d028b4624e.png";